import React from "react";
import { Box, Typography, Paper, Button } from "@mui/material";

interface AdCenterSetupPromptProps {
  onSetupAdCenter: () => void;
}

const AdCenterSetupPrompt: React.FC<AdCenterSetupPromptProps> = ({ onSetupAdCenter }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        mt: 3,
        p: 4,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        display: "flex",
        alignItems: "center",
        gap: 3,
        flexDirection: { xs: "column", sm: "row" },
      }}
    >
      <Box
        component="img"
        src="/home/didyouknow.webp"
        alt="Ad center illustration"
        loading="lazy"
        decoding="async"
        sx={{
          width: { xs: 120, sm: 150 },
          height: "auto",
          flexShrink: 0,
        }}
      />
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 400,
            color: "text.primary",
            mb: 1,
          }}
        >
          Set Up Your Ad Center
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            mb: 2,
            lineHeight: 1.6,
          }}
        >
          No more overworking parents and students to fundraise. Let Noticeboard do the work for you.
          Set up your ad center to start earning revenue from local businesses.
        </Typography>
        <Button
          variant="contained"
          onClick={onSetupAdCenter}
          sx={{
            textTransform: "none",
            fontWeight: 400,
            px: 3,
            py: 1,
          }}
        >
          Set Up Ad Center
        </Button>
      </Box>
    </Paper>
  );
};

export default AdCenterSetupPrompt;
